import { render, staticRenderFns } from "./expertcollection.vue?vue&type=template&id=b9ea3e02&scoped=true&"
import script from "./expertcollection.vue?vue&type=script&lang=js&"
export * from "./expertcollection.vue?vue&type=script&lang=js&"
import style0 from "./expertcollection.vue?vue&type=style&index=0&id=b9ea3e02&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea3e02",
  null
  
)

export default component.exports